import { useEffect } from "react";
import { useStore } from "../state/store";
import styles from "./Toast.module.css";

/** Shows the latest server error for a few seconds. */
export function Toast() {
  const error = useStore((s) => s.error);
  const clear = useStore((s) => s.clearError);
  useEffect(() => {
    if (!error) return;
    const t = setTimeout(clear, 4000);
    return () => clearTimeout(t);
  }, [error, clear]);
  if (!error) return null;
  return (
    <div className={styles.toast} role="alert" onClick={clear}>
      {error.message}
    </div>
  );
}
